import React, { Component } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    TextField,
    IconButton,
    Divider
} from '@material-ui/core';
import { Add, Edit, Save, Cancel } from '@material-ui/icons';
import moment from 'moment';
import { addTimeRecordUseCase } from '../services/addTimeRecordUseCase';
import { updateTimeRecordUseCase } from '../services/getTimeRecordsForRangeUseCase';
import './DayDetailModal.css';

class DayDetailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingRecordId: null,
            editData: {},
            addingNew: false,
            newRecord: {
                actionType: 'entrada',
                time: '',
                notes: ''
            }
        };
    }

    handleEdit = (record) => {
        this.setState({
            editingRecordId: record.id,
            editData: {
                timestamp: record.timestamp,
                actionType: record.actionType,
                notes: record.notes || ''
            }
        });
    }

    handleCancelEdit = () => {
        this.setState({
            editingRecordId: null,
            editData: {}
        });
    }

    handleSaveEdit = async () => {
        const { editingRecordId, editData } = this.state;
        const { employeeId, onUpdate } = this.props;

        try {
            const record = this.props.records.find(r => r.id === editingRecordId);
            await updateTimeRecordUseCase(employeeId, editingRecordId, record.timestamp, {
                timestamp: editData.timestamp,
                actionType: editData.actionType,
                notes: editData.notes
            });

            this.setState({
                editingRecordId: null,
                editData: {}
            });

            if (onUpdate) onUpdate();
        } catch (error) {
            console.error('Error updating record:', error);
            alert('Error al actualizar el fichaje');
        }
    }

    handleAddNew = () => {
        this.setState({ addingNew: true });
    }

    handleCancelAdd = () => {
        this.setState({
            addingNew: false,
            newRecord: {
                actionType: 'entrada',
                time: '',
                notes: ''
            }
        });
    }

    handleSaveNew = async () => {
        const { newRecord } = this.state;
        const { employeeId, date, onUpdate } = this.props;

        if (!newRecord.time) {
            alert('La hora es obligatoria');
            return;
        }

        try {
            // Combine date with time
            const [hours, minutes] = newRecord.time.split(':');
            const timestamp = moment(date)
                .hours(parseInt(hours))
                .minutes(parseInt(minutes))
                .seconds(0)
                .valueOf();

            await addTimeRecordUseCase({
                employeeId,
                actionType: newRecord.actionType,
                timestamp,
                notes: newRecord.notes,
                authMethod: 'manual',
                location: null
            });

            this.setState({
                addingNew: false,
                newRecord: {
                    actionType: 'entrada',
                    time: '',
                    notes: ''
                }
            });

            if (onUpdate) onUpdate();
        } catch (error) {
            console.error('Error adding record:', error);
            alert('Error al añadir fichaje');
        }
    }

    handleEditChange = (field, value) => {
        this.setState({
            editData: {
                ...this.state.editData,
                [field]: value
            }
        });
    }

    handleNewChange = (field, value) => {
        this.setState({
            newRecord: {
                ...this.state.newRecord,
                [field]: value
            }
        });
    }

    render() {
        const { open, onClose, records, employeeName, date } = this.props;
        const { editingRecordId, editData, addingNew, newRecord } = this.state;

        const dateStr = moment(date).format('dddd, D [de] MMMM [de] YYYY');

        return (
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>
                    <Typography variant="h6">
                        Fichajes de {employeeName}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {dateStr}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Add />}
                        onClick={this.handleAddNew}
                        disabled={addingNew}
                        style={{ marginBottom: '20px' }}
                    >
                        Añadir Fichaje Manual
                    </Button>

                    <Paper>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Hora</strong></TableCell>
                                    <TableCell><strong>Tipo</strong></TableCell>
                                    <TableCell><strong>Ubicación</strong></TableCell>
                                    <TableCell><strong>Dispositivo</strong></TableCell>
                                    <TableCell><strong>Notas</strong></TableCell>
                                    <TableCell align="right"><strong>Acciones</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {addingNew && (
                                    <TableRow style={{ backgroundColor: '#e3f2fd' }}>
                                        <TableCell>
                                            <TextField
                                                type="time"
                                                value={newRecord.time}
                                                onChange={(e) => this.handleNewChange('time', e.target.value)}
                                                size="small"
                                                fullWidth
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <select
                                                value={newRecord.actionType}
                                                onChange={(e) => this.handleNewChange('actionType', e.target.value)}
                                                style={{ padding: '8px', width: '100%' }}
                                            >
                                                <option value="entrada">Entrada</option>
                                                <option value="salida">Salida</option>
                                            </select>
                                        </TableCell>
                                        <TableCell colSpan={2}>
                                            <Typography variant="caption" color="textSecondary">
                                                Manual
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={newRecord.notes}
                                                onChange={(e) => this.handleNewChange('notes', e.target.value)}
                                                size="small"
                                                fullWidth
                                                placeholder="Notas..."
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton onClick={this.handleSaveNew} color="primary" size="small">
                                                <Save />
                                            </IconButton>
                                            <IconButton onClick={this.handleCancelAdd} size="small">
                                                <Cancel />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {records && records.length > 0 ? (
                                    records.map((record) => (
                                        <TableRow key={record.id}>
                                            {editingRecordId === record.id ? (
                                                <>
                                                    <TableCell>
                                                        <TextField
                                                            type="time"
                                                            value={moment(editData.timestamp).format('HH:mm')}
                                                            onChange={(e) => {
                                                                const [h, m] = e.target.value.split(':');
                                                                const newTimestamp = moment(editData.timestamp)
                                                                    .hours(parseInt(h))
                                                                    .minutes(parseInt(m))
                                                                    .valueOf();
                                                                this.handleEditChange('timestamp', newTimestamp);
                                                            }}
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <select
                                                            value={editData.actionType}
                                                            onChange={(e) => this.handleEditChange('actionType', e.target.value)}
                                                            style={{ padding: '8px', width: '100%' }}
                                                        >
                                                            <option value="entrada">Entrada</option>
                                                            <option value="salida">Salida</option>
                                                        </select>
                                                    </TableCell>
                                                    <TableCell colSpan={2}>-</TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            value={editData.notes}
                                                            onChange={(e) => this.handleEditChange('notes', e.target.value)}
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <IconButton onClick={this.handleSaveEdit} color="primary" size="small">
                                                            <Save />
                                                        </IconButton>
                                                        <IconButton onClick={this.handleCancelEdit} size="small">
                                                            <Cancel />
                                                        </IconButton>
                                                    </TableCell>
                                                </>
                                            ) : (
                                                <>
                                                    <TableCell>
                                                        {moment(record.timestamp).format('HH:mm')}
                                                        {record.manualCorrection && (
                                                            <Typography variant="caption" color="primary" style={{ marginLeft: '8px' }}>
                                                                (Manual)
                                                            </Typography>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {record.actionType === 'entrada' ? 'Entrada' : 'Salida'}
                                                    </TableCell>
                                                    <TableCell>
                                                        {record.location ? (
                                                            <Typography variant="caption">
                                                                {record.location.address || `${record.location.lat}, ${record.location.lng}`}
                                                            </Typography>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant="caption">
                                                            {record.deviceInfo ? record.deviceInfo.substring(0, 30) + '...' : '-'}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        {record.notes || '-'}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <IconButton
                                                            onClick={() => this.handleEdit(record)}
                                                            color="primary"
                                                            size="small"
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                    </TableCell>
                                                </>
                                            )}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            <Typography color="textSecondary">
                                                No hay fichajes para este día
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default DayDetailModal;
